import React from 'react';
import Icon from './Icon';

const HomeIcon = (props) => (
    <Icon {...props}>
        <path
            d="M3 10L12 3L21 10V20A1 1 0 0 1 20 21H15A1 1 0 0 1 14 20V16A2 2 0 0 0 10 16V20A1 1 0 0 1 9 21H4A1 1 0 0 1 3 20Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default HomeIcon;